import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "my-reservations-wrapper" }
const _hoisted_2 = { class: "top-navigation" }
const _hoisted_3 = { class: "nav-left" }
const _hoisted_4 = { class: "nav-right" }
const _hoisted_5 = { class: "el-dropdown-link" }
const _hoisted_6 = { class: "reservations-container" }
const _hoisted_7 = { class: "page-header" }
const _hoisted_8 = { class: "page-title" }
const _hoisted_9 = { class: "page-subtitle" }
const _hoisted_10 = { class: "search-form-section" }
const _hoisted_11 = { class: "search-form" }
const _hoisted_12 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_13 = {
  key: 1,
  class: "reservations-list"
}
const _hoisted_14 = { class: "card-header" }
const _hoisted_15 = { class: "reservation-id" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "info-row" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "info-row" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "info-row" }
const _hoisted_24 = { class: "label" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "info-row" }
const _hoisted_27 = { class: "label" }
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "info-row" }
const _hoisted_30 = { class: "label" }
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "card-footer" }
const _hoisted_33 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_34 = {
  key: 0,
  class: "detail-content"
}
const _hoisted_35 = {
  key: 0,
  class: "detail-section"
}
const _hoisted_36 = { class: "detail-row" }
const _hoisted_37 = { class: "detail-label" }
const _hoisted_38 = {
  key: 1,
  class: "detail-section"
}
const _hoisted_39 = { class: "detail-row" }
const _hoisted_40 = { class: "detail-label" }
const _hoisted_41 = { class: "detail-row" }
const _hoisted_42 = { class: "detail-label" }
const _hoisted_43 = { class: "detail-row" }
const _hoisted_44 = { class: "detail-label" }
const _hoisted_45 = { class: "detail-row" }
const _hoisted_46 = { class: "detail-label" }
const _hoisted_47 = { class: "detail-row" }
const _hoisted_48 = { class: "detail-label" }
const _hoisted_49 = { class: "detail-row" }
const _hoisted_50 = { class: "detail-label" }
const _hoisted_51 = { class: "detail-row" }
const _hoisted_52 = { class: "detail-label" }
const _hoisted_53 = {
  key: 0,
  style: {"margin-top":"16px"}
}
const _hoisted_54 = { class: "images-grid" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["src"]
const _hoisted_57 = { class: "play-icon" }
const _hoisted_58 = ["src", "alt", "onClick"]
const _hoisted_59 = {
  key: 2,
  class: "detail-section confirm-actions-section"
}
const _hoisted_60 = { class: "confirm-notice" }
const _hoisted_61 = { class: "confirm-buttons" }
const _hoisted_62 = {
  key: 3,
  class: "detail-section"
}
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "detail-row" }
const _hoisted_65 = { class: "detail-label" }
const _hoisted_66 = { class: "amount" }
const _hoisted_67 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_68 = { class: "detail-label" }
const _hoisted_69 = { class: "detail-row" }
const _hoisted_70 = { class: "detail-label" }
const _hoisted_71 = { class: "detail-row" }
const _hoisted_72 = { class: "detail-label" }
const _hoisted_73 = {
  key: 1,
  style: {"margin-top":"8px"}
}
const _hoisted_74 = { class: "images-grid" }
const _hoisted_75 = ["src", "onClick"]
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { class: "detail-row" }
const _hoisted_78 = { class: "detail-label" }
const _hoisted_79 = { class: "amount" }
const _hoisted_80 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_81 = { class: "detail-label" }
const _hoisted_82 = { class: "detail-row" }
const _hoisted_83 = { class: "detail-label" }
const _hoisted_84 = { class: "detail-row" }
const _hoisted_85 = { class: "detail-label" }
const _hoisted_86 = {
  key: 1,
  style: {"margin-top":"8px"}
}
const _hoisted_87 = { class: "images-grid" }
const _hoisted_88 = ["src", "onClick"]
const _hoisted_89 = {
  key: 2,
  class: "detail-row",
  style: {"margin-top":"16px","padding-top":"16px","border-top":"2px solid #673ab7"}
}
const _hoisted_90 = { class: "detail-label" }
const _hoisted_91 = { class: "amount-total" }
const _hoisted_92 = {
  key: 4,
  class: "detail-section"
}
const _hoisted_93 = { class: "detail-row" }
const _hoisted_94 = { class: "detail-label" }
const _hoisted_95 = { class: "detail-row" }
const _hoisted_96 = { class: "detail-label" }
const _hoisted_97 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_98 = { class: "detail-label" }
const _hoisted_99 = {
  key: 1,
  style: {"margin-top":"8px"}
}
const _hoisted_100 = { class: "images-grid" }
const _hoisted_101 = ["src", "onClick"]
const _hoisted_102 = {
  key: 5,
  class: "detail-section"
}
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { class: "detail-row" }
const _hoisted_105 = { class: "detail-label" }
const _hoisted_106 = { class: "detail-row" }
const _hoisted_107 = { class: "detail-label" }
const _hoisted_108 = { key: 0 }
const _hoisted_109 = { class: "images-grid" }
const _hoisted_110 = ["src", "onClick"]
const _hoisted_111 = { key: 1 }
const _hoisted_112 = { class: "detail-row" }
const _hoisted_113 = { class: "detail-label" }
const _hoisted_114 = { class: "detail-row" }
const _hoisted_115 = { class: "detail-label" }
const _hoisted_116 = { key: 0 }
const _hoisted_117 = { class: "images-grid" }
const _hoisted_118 = ["src", "onClick"]
const _hoisted_119 = { key: 2 }
const _hoisted_120 = { class: "detail-row" }
const _hoisted_121 = { class: "detail-label" }
const _hoisted_122 = { class: "detail-row" }
const _hoisted_123 = { class: "detail-label" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { class: "images-grid" }
const _hoisted_126 = ["src", "onClick"]
const _hoisted_127 = {
  key: 6,
  class: "detail-section"
}
const _hoisted_128 = { class: "detail-row" }
const _hoisted_129 = { class: "detail-label" }
const _hoisted_130 = { class: "detail-row" }
const _hoisted_131 = { class: "detail-label" }
const _hoisted_132 = { class: "amount" }
const _hoisted_133 = { class: "detail-row" }
const _hoisted_134 = { class: "detail-label" }
const _hoisted_135 = { class: "detail-row" }
const _hoisted_136 = { class: "detail-label" }
const _hoisted_137 = { class: "amount" }
const _hoisted_138 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_139 = { class: "detail-label" }
const _hoisted_140 = {
  key: 1,
  style: {"margin-top":"8px"}
}
const _hoisted_141 = { class: "images-grid" }
const _hoisted_142 = ["src", "onClick"]
const _hoisted_143 = {
  key: 2,
  style: {"margin-top":"16px"}
}
const _hoisted_144 = { class: "detail-label" }
const _hoisted_145 = ["src"]
const _hoisted_146 = {
  key: 7,
  class: "detail-section review-section"
}
const _hoisted_147 = {
  key: 0,
  class: "review-block"
}
const _hoisted_148 = { class: "review-block-title" }
const _hoisted_149 = { class: "review-card technician-review" }
const _hoisted_150 = { class: "review-header" }
const _hoisted_151 = { class: "reviewer-info" }
const _hoisted_152 = { class: "reviewer-name" }
const _hoisted_153 = { class: "review-time" }
const _hoisted_154 = {
  key: 0,
  class: "review-content"
}
const _hoisted_155 = {
  key: 1,
  class: "review-block"
}
const _hoisted_156 = { class: "review-block-title" }
const _hoisted_157 = { class: "review-card customer-review" }
const _hoisted_158 = { class: "review-header" }
const _hoisted_159 = { class: "reviewer-info" }
const _hoisted_160 = { class: "reviewer-name" }
const _hoisted_161 = { class: "review-time" }
const _hoisted_162 = {
  key: 0,
  class: "review-content"
}
const _hoisted_163 = {
  key: 1,
  class: "review-pending-notice"
}
const _hoisted_164 = {
  key: 2,
  class: "no-review"
}
const _hoisted_165 = {
  key: 3,
  class: "review-stats"
}
const _hoisted_166 = { class: "stats-title" }
const _hoisted_167 = { class: "stats-content" }
const _hoisted_168 = { class: "stat-item" }
const _hoisted_169 = { class: "stat-label" }
const _hoisted_170 = { class: "stat-item" }
const _hoisted_171 = { class: "stat-label" }
const _hoisted_172 = { class: "stat-value" }
const _hoisted_173 = { class: "media-preview-container" }
const _hoisted_174 = ["src"]
const _hoisted_175 = ["src"]
const _hoisted_176 = { class: "rating-container" }

import { ref, computed, onMounted, reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { ArrowDown, Loading, Phone, Message, HomeFilled, Check, Close, WarningFilled, Star, VideoPlay } from '@element-plus/icons-vue'
import { ElMessageBox } from 'element-plus'
import axios from 'axios'


export default /*@__PURE__*/_defineComponent({
  __name: 'MyReservations',
  setup(__props) {

const { t, locale } = useI18n()

const searchForm = reactive({
  phone: '',
  email: ''
})
const loading = ref(false)
const reservations = ref<any[]>([])
const detailDialogVisible = ref(false)
const currentDetail = ref<any>(null)
const mediaPreviewVisible = ref(false)
const currentPreviewUrl = ref('')
const isPreviewVideo = ref(false)
const rejectDialogVisible = ref(false)
const rejectReason = ref('')
const confirmLoading = ref(false)
const rejectLoading = ref(false)
const currentOrderId = ref<number | null>(null)
const reviewDialogVisible = ref(false)
const reviewLoading = ref(false)
const reviewForm = reactive({
  rating: 5,
  content: ''
})

// Rating texts for display
const ratingTexts = computed(() => [
  t('myReservations.ratingTexts.1'),
  t('myReservations.ratingTexts.2'),
  t('myReservations.ratingTexts.3'),
  t('myReservations.ratingTexts.4'),
  t('myReservations.ratingTexts.5')
])

const currentLanguageName = computed(() => {
  return t(`language.${locale.value.replace('-', '')}`)
})

const handleLanguageChange = (lang: string) => {
  locale.value = lang
}

onMounted(() => {
  // Auto search if phone is provided in query
  const urlParams = new URLSearchParams(window.location.search)
  const phone = urlParams.get('phone')
  if (phone) {
    searchForm.phone = phone
    searchReservations()
  }
})

const searchReservations = async () => {
  // Both phone and email must be filled
  if (!searchForm.phone || !searchForm.email) {
    ElMessage.warning(t('myReservations.enterSearchCriteria'))
    return
  }

  loading.value = true
  try {
    const langMap: Record<string, string> = {
      'zh-TW': 'zh_TW',
      'zh-CN': 'zh_CN'
    }
    const apiLang = langMap[locale.value] || 'zh_TW'

    // Build query params - both phone and email are required
    const params: any = { 
      lang: apiLang,
      phone: searchForm.phone,
      email: searchForm.email
    }

    const response = await axios.get('/api/reservation/list', {
      params,
      headers: {
        'Accept-Language': apiLang
      }
    })

    if (response.data.code === 200) {
      reservations.value = response.data.data?.list || []
      if (reservations.value.length === 0) {
        ElMessage.info(t('myReservations.noData'))
      }
    } else {
      ElMessage.error(response.data.message || t('myReservations.searchFailed'))
    }
  } catch (error: any) {
    console.error('Search error:', error)
    ElMessage.error(error.response?.data?.message || t('myReservations.searchFailed'))
  } finally {
    loading.value = false
  }
}

const viewDetail = async (reservationId: number) => {
  try {
    const langMap: Record<string, string> = {
      'zh-TW': 'zh_TW',
      'zh-CN': 'zh_CN'
    }
    const apiLang = langMap[locale.value] || 'zh_TW'

    // Get reservation detail
    const detailResponse = await axios.get(`/api/reservation/${reservationId}`, {
      params: { lang: apiLang },
      headers: { 'Accept-Language': apiLang }
    })

    if (detailResponse.data.code === 200) {
      currentDetail.value = detailResponse.data.data
      // Store orderId for confirm/reject operations
      currentOrderId.value = currentDetail.value.orderId || currentDetail.value.orderDemand?.orderId || reservationId
      detailDialogVisible.value = true
    }
  } catch (error: any) {
    console.error('Get detail error:', error)
    ElMessage.error(error.response?.data?.message || t('myReservations.loadFailed'))
  }
}

const getStatusType = (status: string) => {
  const statusMap: Record<string, any> = {
    'PENDING_REVIEW': 'info',
    'PENDING': 'warning',
    'PENDING_TECHNICIAN': 'warning',
    'QUOTED': 'primary',
    'PENDING_CUSTOMER_CONFIRM': 'warning',
    'MATERIAL_PREPARING': 'primary',
    'PENDING_CONSTRUCTION': 'warning',
    'CONSTRUCTING': 'primary',
    'PENDING_ACCEPTANCE': 'warning',
    'ACCEPTANCE': 'primary',
    'COMPLETED': 'success',
    'CLOSED': 'success',
    'CANCELLED': 'info'
  }
  return statusMap[status] || 'info'
}

const getStatusText = (status: string) => {
  return t(`myReservations.status.${status}`)
}

const formatFileSize = (bytes: number) => {
  if (!bytes) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
}

// Check if file is video by fileType
const isVideo = (fileType: string | undefined) => {
  return fileType?.startsWith('video/') || false
}

// Preview media (image or video)
const previewMedia = (url: string, fileType?: string) => {
  currentPreviewUrl.value = url
  isPreviewVideo.value = isVideo(fileType)
  mediaPreviewVisible.value = true
}

const goToHome = () => {
  window.location.href = '/'
}

// Confirm quotation
const confirmQuotation = async () => {
  if (!currentDetail.value) return
  
  try {
    await ElMessageBox.confirm(
      t('myReservations.confirmQuotationMessage'),
      t('myReservations.confirmQuotation'),
      {
        confirmButtonText: t('myReservations.confirm'),
        cancelButtonText: t('myReservations.cancel'),
        type: 'warning'
      }
    )
    
    confirmLoading.value = true
    const langMap: Record<string, string> = {
      'zh-TW': 'zh_TW',
      'zh-CN': 'zh_CN'
    }
    const apiLang = langMap[locale.value] || 'zh_TW'
    
    const response = await axios.post(
      `/api/reservation/customer/confirm-quotation?lang=${apiLang}`,
      {
        orderId: currentOrderId.value,
        phone: searchForm.phone,
        email: searchForm.email
      },
      {
        headers: { 'Accept-Language': apiLang }
      }
    )
    
    if (response.data.code === 200) {
      ElMessage.success(t('myReservations.confirmSuccess'))
      detailDialogVisible.value = false
      // Refresh the list
      searchReservations()
    } else {
      ElMessage.error(response.data.message || t('myReservations.confirmFailed'))
    }
  } catch (error: any) {
    if (error !== 'cancel') {
      console.error('Confirm quotation error:', error)
      ElMessage.error(error.response?.data?.message || t('myReservations.confirmFailed'))
    }
  } finally {
    confirmLoading.value = false
  }
}

// Show reject dialog
const showRejectDialog = () => {
  rejectReason.value = ''
  rejectDialogVisible.value = true
}

// Reject quotation
const rejectQuotation = async () => {
  if (!currentDetail.value) return
  
  if (!rejectReason.value.trim()) {
    ElMessage.warning(t('myReservations.rejectReasonRequired'))
    return
  }
  
  rejectLoading.value = true
  try {
    const langMap: Record<string, string> = {
      'zh-TW': 'zh_TW',
      'zh-CN': 'zh_CN'
    }
    const apiLang = langMap[locale.value] || 'zh_TW'
    
    const response = await axios.post(
      `/api/reservation/customer/reject-quotation?lang=${apiLang}`,
      {
        orderId: currentOrderId.value,
        phone: searchForm.phone,
        email: searchForm.email,
        reason: rejectReason.value.trim()
      },
      {
        headers: { 'Accept-Language': apiLang }
      }
    )
    
    if (response.data.code === 200) {
      ElMessage.success(t('myReservations.rejectSuccess'))
      rejectDialogVisible.value = false
      detailDialogVisible.value = false
      // Refresh the list
      searchReservations()
    } else {
      ElMessage.error(response.data.message || t('myReservations.rejectFailed'))
    }
  } catch (error: any) {
    console.error('Reject quotation error:', error)
    ElMessage.error(error.response?.data?.message || t('myReservations.rejectFailed'))
  } finally {
    rejectLoading.value = false
  }
}

// Show review dialog
const showReviewDialog = () => {
  reviewForm.rating = 5
  reviewForm.content = ''
  reviewDialogVisible.value = true
}

// Submit review
const submitReview = async () => {
  if (!currentOrderId.value) return
  
  if (reviewForm.rating < 1 || reviewForm.rating > 5) {
    ElMessage.warning(t('myReservations.ratingRequired'))
    return
  }
  
  reviewLoading.value = true
  try {
    const langMap: Record<string, string> = {
      'zh-TW': 'zh_TW',
      'zh-CN': 'zh_CN'
    }
    const apiLang = langMap[locale.value] || 'zh_TW'
    
    const response = await axios.post(
      `/api/reservation/customer/review-technician?lang=${apiLang}`,
      {
        orderId: currentOrderId.value,
        phone: searchForm.phone,
        email: searchForm.email,
        rating: reviewForm.rating,
        content: reviewForm.content.trim() || undefined
      },
      {
        headers: { 'Accept-Language': apiLang }
      }
    )
    
    if (response.data.code === 200) {
      ElMessage.success(t('myReservations.reviewSuccess'))
      reviewDialogVisible.value = false
      // Refresh detail to show the review
      if (currentOrderId.value) {
        viewDetail(currentOrderId.value)
      }
    } else {
      ElMessage.error(response.data.message || t('myReservations.reviewFailed'))
    }
  } catch (error: any) {
    console.error('Submit review error:', error)
    ElMessage.error(error.response?.data?.message || t('myReservations.reviewFailed'))
  } finally {
    reviewLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          text: "",
          onClick: goToHome
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(HomeFilled))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_unref(t)('myReservations.backToHome')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_dropdown, { onCommand: handleLanguageChange }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { command: "zh-TW" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('language.zhTW')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, { command: "zh-CN" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('language.zhCN')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(currentLanguageName.value) + " ", 1),
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowDown))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h1", _hoisted_8, _toDisplayString(_unref(t)('myReservations.title')), 1),
        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('myReservations.subtitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_form, {
            model: searchForm,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('myReservations.searchBy')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: searchForm.phone,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.phone) = $event)),
                    placeholder: _unref(t)('myReservations.phonePlaceholder'),
                    clearable: ""
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Phone))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: searchForm.email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.email) = $event)),
                    placeholder: _unref(t)('myReservations.emailPlaceholder'),
                    clearable: ""
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Message))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: searchReservations,
                    size: "large",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('myReservations.search')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_el_icon, {
              class: "is-loading",
              size: 40
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Loading))
              ]),
              _: 1
            })
          ]))
        : (reservations.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reservations.value, (reservation) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: reservation.reservationId,
                  class: "reservation-card"
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('myReservations.caseNo')) + ": " + _toDisplayString(reservation.caseNo), 1),
                    _createVNode(_component_el_tag, {
                      type: getStatusType(reservation.status)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(reservation.statusName || getStatusText(reservation.status)), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('form.name')) + ":", 1),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(reservation.realName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('form.phone')) + ":", 1),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(reservation.phone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('form.address')) + ":", 1),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(reservation.address), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(t)('form.repairType')) + ":", 1),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(reservation.repairType), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)('myReservations.createTime')) + ":", 1),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(reservation.createTime), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: ($event: any) => (viewDetail(reservation.reservationId))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('myReservations.viewDetail')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createVNode(_component_el_empty, {
                description: _unref(t)('myReservations.noData')
              }, null, 8, ["description"])
            ]))
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: detailDialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((detailDialogVisible).value = $event)),
      title: _unref(t)('myReservations.detailTitle'),
      width: "90%",
      style: {"max-width":"800px"}
    }, {
      default: _withCtx(() => [
        (currentDetail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              (currentDetail.value.currentStage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(t)('myReservations.currentStage')) + ":", 1),
                      _createVNode(_component_el_tag, {
                        type: getStatusType(currentDetail.value.status),
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentDetail.value.statusName || getStatusText(currentDetail.value.status)), 1)
                        ]),
                        _: 1
                      }, 8, ["type"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (currentDetail.value.orderDemand)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("h3", null, _toDisplayString(_unref(t)('myReservations.basicInfo')), 1),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(t)('myReservations.caseNo')) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(currentDetail.value.orderDemand.caseNo), 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(t)('form.name')) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(currentDetail.value.orderDemand.realName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(t)('form.phone')) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(currentDetail.value.orderDemand.phone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(t)('form.address')) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(currentDetail.value.orderDemand.address), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(t)('form.repairType')) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(currentDetail.value.orderDemand.repairType), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(t)('form.description')) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(currentDetail.value.orderDemand.supplementDesc || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_unref(t)('myReservations.createTime')) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(currentDetail.value.orderDemand.createTime), 1)
                    ]),
                    (currentDetail.value.orderDemand.images && currentDetail.value.orderDemand.images.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentDetail.value.orderDemand.images, (media) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: media.imageId,
                                class: "media-item"
                              }, [
                                (isVideo(media.fileType))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "video-thumbnail",
                                      onClick: ($event: any) => (previewMedia(media.imageUrl, media.fileType))
                                    }, [
                                      _createElementVNode("video", {
                                        src: media.imageUrl,
                                        class: "detail-video-thumb"
                                      }, null, 8, _hoisted_56),
                                      _createElementVNode("div", _hoisted_57, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(VideoPlay))
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ], 8, _hoisted_55))
                                  : (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: media.imageUrl,
                                      alt: media.fileName || 'Image',
                                      class: "detail-image",
                                      onClick: ($event: any) => (previewMedia(media.imageUrl, media.fileType))
                                    }, null, 8, _hoisted_58))
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (currentDetail.value.status === 'PENDING_CUSTOMER_CONFIRM')
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(WarningFilled))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('myReservations.pendingConfirmNotice')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createVNode(_component_el_button, {
                        type: "success",
                        size: "large",
                        onClick: confirmQuotation,
                        loading: confirmLoading.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Check))
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(t)('myReservations.confirmQuotation')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"]),
                      _createVNode(_component_el_button, {
                        type: "danger",
                        size: "large",
                        onClick: showRejectDialog
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Close))
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(t)('myReservations.rejectQuotation')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (currentDetail.value.quotationStage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createElementVNode("h3", null, _toDisplayString(_unref(t)('myReservations.quotationStage')), 1),
                    (currentDetail.value.quotationStage.mainQuotations && currentDetail.value.quotationStage.mainQuotations.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentDetail.value.quotationStage.mainQuotations, (quote) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: quote.quotationId,
                              class: "quote-item"
                            }, [
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(t)('myReservations.quotedAmount')) + ":", 1),
                                _createElementVNode("span", _hoisted_66, "NT$ " + _toDisplayString(quote.quotedAmount), 1)
                              ]),
                              (quote.workDescription)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                    _createElementVNode("span", _hoisted_68, _toDisplayString(_unref(t)('myReservations.quotationDesc')) + ":", 1),
                                    _createElementVNode("span", null, _toDisplayString(quote.workDescription), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_69, [
                                _createElementVNode("span", _hoisted_70, _toDisplayString(_unref(t)('myReservations.quotationTime')) + ":", 1),
                                _createElementVNode("span", null, _toDisplayString(quote.quotedTime), 1)
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _createElementVNode("span", _hoisted_72, _toDisplayString(_unref(t)('myReservations.status.label')) + ":", 1),
                                _createElementVNode("span", null, _toDisplayString(quote.statusName), 1)
                              ]),
                              (quote.images && quote.images.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                    _createElementVNode("div", _hoisted_74, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quote.images, (image) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: image.imageId,
                                          class: "image-item"
                                        }, [
                                          _createElementVNode("img", {
                                            src: image.imageUrl,
                                            class: "detail-image",
                                            onClick: ($event: any) => (previewMedia(image.imageUrl, image.fileType))
                                          }, null, 8, _hoisted_75)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (currentDetail.value.quotationStage.subQuotations && currentDetail.value.quotationStage.subQuotations.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentDetail.value.quotationStage.subQuotations, (quote) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: quote.quotationId,
                              class: "quote-item"
                            }, [
                              _createElementVNode("div", _hoisted_77, [
                                _createElementVNode("span", _hoisted_78, _toDisplayString(_unref(t)('myReservations.quotedAmount')) + ":", 1),
                                _createElementVNode("span", _hoisted_79, "NT$ " + _toDisplayString(quote.quotedAmount), 1)
                              ]),
                              (quote.workDescription)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                    _createElementVNode("span", _hoisted_81, _toDisplayString(_unref(t)('myReservations.quotationDesc')) + ":", 1),
                                    _createElementVNode("span", null, _toDisplayString(quote.workDescription), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("span", _hoisted_83, _toDisplayString(_unref(t)('myReservations.quotationTime')) + ":", 1),
                                _createElementVNode("span", null, _toDisplayString(quote.quotedTime), 1)
                              ]),
                              _createElementVNode("div", _hoisted_84, [
                                _createElementVNode("span", _hoisted_85, _toDisplayString(_unref(t)('myReservations.status.label')) + ":", 1),
                                _createElementVNode("span", null, _toDisplayString(quote.statusName), 1)
                              ]),
                              (quote.images && quote.images.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                    _createElementVNode("div", _hoisted_87, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quote.images, (image) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: image.imageId,
                                          class: "image-item"
                                        }, [
                                          _createElementVNode("img", {
                                            src: image.imageUrl,
                                            class: "detail-image",
                                            onClick: ($event: any) => (previewMedia(image.imageUrl, image.fileType))
                                          }, null, 8, _hoisted_88)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (currentDetail.value.quotationStage.totalApprovedAmount)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                          _createElementVNode("span", _hoisted_90, _toDisplayString(_unref(t)('myReservations.totalApprovedAmount')) + ":", 1),
                          _createElementVNode("span", _hoisted_91, "NT$ " + _toDisplayString(currentDetail.value.quotationStage.totalApprovedAmount), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (currentDetail.value.materialStage && currentDetail.value.materialStage.materials && currentDetail.value.materialStage.materials.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                    _createElementVNode("h3", null, _toDisplayString(_unref(t)('myReservations.materialStage')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentDetail.value.materialStage.materials, (material) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: material.materialId,
                        class: "material-item"
                      }, [
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("span", _hoisted_94, _toDisplayString(_unref(t)('myReservations.materialName')) + ":", 1),
                          _createElementVNode("span", null, _toDisplayString(material.materialName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_95, [
                          _createElementVNode("span", _hoisted_96, _toDisplayString(_unref(t)('myReservations.materialPrice')) + ":", 1),
                          _createElementVNode("span", null, "NT$ " + _toDisplayString(material.materialPrice), 1)
                        ]),
                        (material.remark)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                              _createElementVNode("span", _hoisted_98, _toDisplayString(_unref(t)('myReservations.remark')) + ":", 1),
                              _createElementVNode("span", null, _toDisplayString(material.remark), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (material.images && material.images.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                              _createElementVNode("div", _hoisted_100, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(material.images, (image) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: image.imageId,
                                    class: "image-item"
                                  }, [
                                    _createElementVNode("img", {
                                      src: image.imageUrl,
                                      class: "detail-image",
                                      onClick: ($event: any) => (previewMedia(image.imageUrl, image.fileType))
                                    }, null, 8, _hoisted_101)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (currentDetail.value.constructionStage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                    _createElementVNode("h3", null, _toDisplayString(_unref(t)('myReservations.constructionStage')), 1),
                    (currentDetail.value.constructionStage.beforeRecords && currentDetail.value.constructionStage.beforeRecords.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                          _createElementVNode("h4", null, _toDisplayString(_unref(t)('myReservations.beforeConstruction')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentDetail.value.constructionStage.beforeRecords, (record) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: record.recordId,
                              class: "construction-record"
                            }, [
                              _createElementVNode("div", _hoisted_104, [
                                _createElementVNode("span", _hoisted_105, _toDisplayString(_unref(t)('myReservations.description')) + ":", 1),
                                _createElementVNode("span", null, _toDisplayString(record.stageDesc), 1)
                              ]),
                              _createElementVNode("div", _hoisted_106, [
                                _createElementVNode("span", _hoisted_107, _toDisplayString(_unref(t)('myReservations.recordTime')) + ":", 1),
                                _createElementVNode("span", null, _toDisplayString(record.createTime), 1)
                              ]),
                              (record.images && record.images.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                    _createElementVNode("div", _hoisted_109, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.images, (image) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: image.imageId,
                                          class: "image-item"
                                        }, [
                                          _createElementVNode("img", {
                                            src: image.imageUrl,
                                            class: "detail-image",
                                            onClick: ($event: any) => (previewMedia(image.imageUrl, image.fileType))
                                          }, null, 8, _hoisted_110)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (currentDetail.value.constructionStage.duringRecords && currentDetail.value.constructionStage.duringRecords.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                          _createElementVNode("h4", null, _toDisplayString(_unref(t)('myReservations.duringConstruction')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentDetail.value.constructionStage.duringRecords, (record) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: record.recordId,
                              class: "construction-record"
                            }, [
                              _createElementVNode("div", _hoisted_112, [
                                _createElementVNode("span", _hoisted_113, _toDisplayString(_unref(t)('myReservations.description')) + ":", 1),
                                _createElementVNode("span", null, _toDisplayString(record.stageDesc), 1)
                              ]),
                              _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("span", _hoisted_115, _toDisplayString(_unref(t)('myReservations.recordTime')) + ":", 1),
                                _createElementVNode("span", null, _toDisplayString(record.createTime), 1)
                              ]),
                              (record.images && record.images.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                    _createElementVNode("div", _hoisted_117, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.images, (image) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: image.imageId,
                                          class: "image-item"
                                        }, [
                                          _createElementVNode("img", {
                                            src: image.imageUrl,
                                            class: "detail-image",
                                            onClick: ($event: any) => (previewMedia(image.imageUrl, image.fileType))
                                          }, null, 8, _hoisted_118)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (currentDetail.value.constructionStage.afterRecords && currentDetail.value.constructionStage.afterRecords.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                          _createElementVNode("h4", null, _toDisplayString(_unref(t)('myReservations.afterConstruction')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentDetail.value.constructionStage.afterRecords, (record) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: record.recordId,
                              class: "construction-record"
                            }, [
                              _createElementVNode("div", _hoisted_120, [
                                _createElementVNode("span", _hoisted_121, _toDisplayString(_unref(t)('myReservations.description')) + ":", 1),
                                _createElementVNode("span", null, _toDisplayString(record.stageDesc), 1)
                              ]),
                              _createElementVNode("div", _hoisted_122, [
                                _createElementVNode("span", _hoisted_123, _toDisplayString(_unref(t)('myReservations.recordTime')) + ":", 1),
                                _createElementVNode("span", null, _toDisplayString(record.createTime), 1)
                              ]),
                              (record.images && record.images.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                    _createElementVNode("div", _hoisted_125, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.images, (image) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: image.imageId,
                                          class: "image-item"
                                        }, [
                                          _createElementVNode("img", {
                                            src: image.imageUrl,
                                            class: "detail-image",
                                            onClick: ($event: any) => (previewMedia(image.imageUrl, image.fileType))
                                          }, null, 8, _hoisted_126)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (currentDetail.value.acceptanceStage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                    _createElementVNode("h3", null, _toDisplayString(_unref(t)('myReservations.acceptanceStage')), 1),
                    _createElementVNode("div", _hoisted_128, [
                      _createElementVNode("span", _hoisted_129, _toDisplayString(_unref(t)('myReservations.completionDate')) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(currentDetail.value.acceptanceStage.completionDate), 1)
                    ]),
                    _createElementVNode("div", _hoisted_130, [
                      _createElementVNode("span", _hoisted_131, _toDisplayString(_unref(t)('myReservations.chargeAmount')) + ":", 1),
                      _createElementVNode("span", _hoisted_132, "NT$ " + _toDisplayString(currentDetail.value.acceptanceStage.chargeAmount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_133, [
                      _createElementVNode("span", _hoisted_134, _toDisplayString(_unref(t)('myReservations.paymentMethod')) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(currentDetail.value.acceptanceStage.paymentMethod), 1)
                    ]),
                    _createElementVNode("div", _hoisted_135, [
                      _createElementVNode("span", _hoisted_136, _toDisplayString(_unref(t)('myReservations.collectionAmount')) + ":", 1),
                      _createElementVNode("span", _hoisted_137, "NT$ " + _toDisplayString(currentDetail.value.acceptanceStage.collectionAmount), 1)
                    ]),
                    (currentDetail.value.acceptanceStage.remark)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                          _createElementVNode("span", _hoisted_139, _toDisplayString(_unref(t)('myReservations.remark')) + ":", 1),
                          _createElementVNode("span", null, _toDisplayString(currentDetail.value.acceptanceStage.remark), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (currentDetail.value.acceptanceStage.images && currentDetail.value.acceptanceStage.images.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                          _createElementVNode("div", _hoisted_141, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentDetail.value.acceptanceStage.images, (image) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: image.imageId,
                                class: "image-item"
                              }, [
                                _createElementVNode("img", {
                                  src: image.imageUrl,
                                  class: "detail-image",
                                  onClick: ($event: any) => (previewMedia(image.imageUrl, image.fileType))
                                }, null, 8, _hoisted_142)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (currentDetail.value.acceptanceStage.customerSignature)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                          _createElementVNode("div", _hoisted_144, _toDisplayString(_unref(t)('myReservations.customerSignature')) + ":", 1),
                          _createElementVNode("img", {
                            src: currentDetail.value.acceptanceStage.customerSignature.imageUrl,
                            class: "signature-image",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (previewMedia(currentDetail.value.acceptanceStage.customerSignature.imageUrl)))
                          }, null, 8, _hoisted_145)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              ((currentDetail.value.status === 'COMPLETED' || currentDetail.value.status === 'CLOSED') && currentDetail.value.reviewStage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                    _createElementVNode("h3", null, _toDisplayString(_unref(t)('myReservations.reviewSection')), 1),
                    (currentDetail.value.reviewStage.technicianReviewed && currentDetail.value.reviewStage.customerReviewed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (currentDetail.value.reviewStage.technicianToCustomer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                _createElementVNode("h4", _hoisted_148, _toDisplayString(_unref(t)('myReservations.technicianReview')), 1),
                                _createElementVNode("div", _hoisted_149, [
                                  _createElementVNode("div", _hoisted_150, [
                                    _createElementVNode("div", _hoisted_151, [
                                      _createElementVNode("span", _hoisted_152, _toDisplayString(currentDetail.value.reviewStage.technicianToCustomer.reviewerName || _unref(t)('myReservations.technician')), 1),
                                      _createElementVNode("span", _hoisted_153, _toDisplayString(currentDetail.value.reviewStage.technicianToCustomer.createTime), 1)
                                    ]),
                                    _createVNode(_component_el_rate, {
                                      "model-value": currentDetail.value.reviewStage.technicianToCustomer.rating,
                                      disabled: "",
                                      size: "small"
                                    }, null, 8, ["model-value"])
                                  ]),
                                  (currentDetail.value.reviewStage.technicianToCustomer.content)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_154, _toDisplayString(currentDetail.value.reviewStage.technicianToCustomer.content), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (currentDetail.value.reviewStage.customerToTechnician)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                                _createElementVNode("h4", _hoisted_156, _toDisplayString(_unref(t)('myReservations.customerReview')), 1),
                                _createElementVNode("div", _hoisted_157, [
                                  _createElementVNode("div", _hoisted_158, [
                                    _createElementVNode("div", _hoisted_159, [
                                      _createElementVNode("span", _hoisted_160, _toDisplayString(_unref(t)('myReservations.myReview')), 1),
                                      _createElementVNode("span", _hoisted_161, _toDisplayString(currentDetail.value.reviewStage.customerToTechnician.createTime), 1)
                                    ]),
                                    _createVNode(_component_el_rate, {
                                      "model-value": currentDetail.value.reviewStage.customerToTechnician.rating,
                                      disabled: "",
                                      size: "small"
                                    }, null, 8, ["model-value"])
                                  ]),
                                  (currentDetail.value.reviewStage.customerToTechnician.content)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_162, _toDisplayString(currentDetail.value.reviewStage.customerToTechnician.content), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (currentDetail.value.reviewStage.customerReviewed && !currentDetail.value.reviewStage.technicianReviewed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Star))
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('myReservations.reviewSubmittedWaiting')), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_164, [
                            _createElementVNode("p", null, _toDisplayString(_unref(t)('myReservations.noReviewYet')), 1),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: showReviewDialog
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Star))
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(_unref(t)('myReservations.writeReview')), 1)
                              ]),
                              _: 1
                            })
                          ])),
                    (currentDetail.value.reviewStage.technicianReviewed && currentDetail.value.reviewStage.customerReviewed && currentDetail.value.reviewStage.technicianAvgRating)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                          _createElementVNode("div", _hoisted_166, _toDisplayString(_unref(t)('myReservations.technicianStats')), 1),
                          _createElementVNode("div", _hoisted_167, [
                            _createElementVNode("div", _hoisted_168, [
                              _createElementVNode("span", _hoisted_169, _toDisplayString(_unref(t)('myReservations.avgRating')) + ":", 1),
                              _createVNode(_component_el_rate, {
                                "model-value": currentDetail.value.reviewStage.technicianAvgRating,
                                disabled: "",
                                size: "small",
                                "show-score": ""
                              }, null, 8, ["model-value"])
                            ]),
                            _createElementVNode("div", _hoisted_170, [
                              _createElementVNode("span", _hoisted_171, _toDisplayString(_unref(t)('myReservations.totalReviews')) + ":", 1),
                              _createElementVNode("span", _hoisted_172, _toDisplayString(currentDetail.value.reviewStage.technicianReviewCount) + " " + _toDisplayString(_unref(t)('myReservations.reviewCount')), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: mediaPreviewVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((mediaPreviewVisible).value = $event)),
      width: "90%",
      style: {"max-width":"1200px"},
      "show-close": true,
      "append-to-body": "",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_173, [
          (isPreviewVideo.value)
            ? (_openBlock(), _createElementBlock("video", {
                key: 0,
                src: currentPreviewUrl.value,
                controls: "",
                autoplay: "",
                class: "preview-video"
              }, null, 8, _hoisted_174))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: currentPreviewUrl.value,
                alt: "Preview",
                class: "preview-image"
              }, null, 8, _hoisted_175))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: rejectDialogVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((rejectDialogVisible).value = $event)),
      title: _unref(t)('myReservations.rejectQuotation'),
      width: "90%",
      style: {"max-width":"500px"},
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (rejectDialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('myReservations.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: rejectQuotation,
          loading: rejectLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('myReservations.confirmReject')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-position": "top" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('myReservations.rejectReason')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: rejectReason.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((rejectReason).value = $event)),
                  type: "textarea",
                  rows: 4,
                  placeholder: _unref(t)('myReservations.rejectReasonPlaceholder')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: reviewDialogVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((reviewDialogVisible).value = $event)),
      title: _unref(t)('myReservations.writeReview'),
      width: "90%",
      style: {"max-width":"500px"},
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (reviewDialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('myReservations.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitReview,
          loading: reviewLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('myReservations.submitReview')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-position": "top" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('myReservations.rating'),
              required: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_176, [
                  _createVNode(_component_el_rate, {
                    modelValue: reviewForm.rating,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((reviewForm.rating) = $event)),
                    texts: ratingTexts.value,
                    "show-text": "",
                    size: "large"
                  }, null, 8, ["modelValue", "texts"])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('myReservations.reviewContent')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: reviewForm.content,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((reviewForm.content) = $event)),
                  type: "textarea",
                  rows: 4,
                  placeholder: _unref(t)('myReservations.reviewContentPlaceholder'),
                  maxlength: "500",
                  "show-word-limit": ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})